module.exports = __webpack_public_path__ + "ed68f99e8b34f1fa559f86abb88f6fd6.png";